import React from 'react'
import { connect } from 'react-redux';
import UpdateHistoryTrack from '../../others/UpdateHistoryTrack';

function InsuranceHistoryTrack(props) {
  const { version_attributes } = props

  const getInsuranceType = (type) => {
    switch (type) {
      case 'PatientVisionInsurance': return 'Vision'
      case 'PatientMedicalInsurance': return 'Medical'
      case 'PatientVisionSecondaryInsurance': return 'Vision Secondary'
      case 'PatientVisionTertiaryInsurance': return 'Vision Tertiary'
      case 'PatientMedicalSecondaryInsurance': return 'Medical Secondary'
      case 'PatientMedicalTertiaryInsurance': return 'Medical Tertiary'
      default: return ''
    }
  }

  const RenderChangedValuesDetails = ({ version }) => {
    return (
      <>
        {version.changed_values?.patient_insurances.map((item, i) => (
          <p
            key={i}
            className='badge bg-primary-light d-flex align-items-center mb-0 w-100 flex-wrap'
          >
            <h6 className='text-primary'>{getInsuranceType(item.type)}: </h6>
            <span className='ml-2'>{item.insurance_name}</span>
            {item.member_id && <span className='ml-2'> | ID: {item.member_id}</span>}
            {item.plan_name && <span className='ml-2'> | Plan: {item.plan_name}</span>}
          </p>
        ))}
      </>
    )
  }

  return (
    <UpdateHistoryTrack
      version_attributes={version_attributes}
      ChangedValuesDetails={RenderChangedValuesDetails}
    />
  )
}

const mapStateToProps = (state) => {
  const { patient: { patient } } = state;
  return {
    version_attributes: patient?.version_attributes,
  }
}

export default connect(mapStateToProps)(InsuranceHistoryTrack)